'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { useQuery } from '@repo/tanstack/query';
export type CmdkLoad = NonNullable<ReturnType<typeof useCmdkLoads>['data']>[number];
export const useCmdkLoads = (search, t0) => {
  const $ = _c(9);
  const perPage = t0 === undefined ? 10 : t0;
  const api = useApi();
  let t1;
  let t2;
  let term;
  if ($[0] !== api.loads.search || $[1] !== perPage || $[2] !== search) {
    term = search.trim();
    t2 = useQuery;
    t1 = api.loads.search.queryOptions({
      input: {
        perPage,
        search: term
      }
    }, {
      staleTime: 30000
    });
    $[0] = api.loads.search;
    $[1] = perPage;
    $[2] = search;
    $[3] = t1;
    $[4] = t2;
    $[5] = term;
  } else {
    t1 = $[3];
    t2 = $[4];
    term = $[5];
  }
  const t3 = term.length >= 1;
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = {
      ...t1,
      enabled: t3,
      select: _temp
    };
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t2(t4);
};
function _temp(page) {
  return page.data;
}